module.exports = __webpack_public_path__ + "img/01-1.855d38da.png";